module.exports = __webpack_public_path__ + "static/media/whatsNewBanner__.94009457.jpg";